import { UrlName } from 'modules/app/types';

export interface ConfigServiceI {
  urls: Record<UrlName, string | undefined>;
  getUrl(name: UrlName): string;
}

class ConfigService implements ConfigServiceI {
  urls: ConfigServiceI['urls'];

  constructor() {
    this.urls = {
      api: window._env_.VITE_APP_API_URL,
      auth: window._env_.VITE_APP_AUTH_URL,
      authApi: window._env_.VITE_APP_PASSWORDLESS_AUTH_API_URL,
      base: window._env_.VITE_APP_API_BASE_URL,
      openNatterApi: window._env_.VITE_APP_OPEN_NATTER_API_URL,
      tagApi: window._env_.VITE_APP_TAG_API_URL,
      accountlessNatalieApi: window._env_.VITE_APP_ACCOUNTLESS_NATALIE_API_URL,
      natalieApi: window._env_.VITE_APP_NATALIE_API_URL,
    };
  }

  getUrl(name: UrlName): string {
    const url = this.urls[name];

    if (!url && name === 'openNatterApi') {
      throw new Error('VITE_APP_OPEN_NATTER_API_URL environment variable is required');
    }
    if (!url && name === 'accountlessNatalieApi') {
      throw new Error('VITE_APP_ACCOUNTLESS_NATALIE_API_URL environment variable is required');
    }
    if (!url && name === 'natalieApi') {
      throw new Error('VITE_APP_NATALIE_API_URL environment variable is required');
    }
    // authApi (VITE_APP_PASSWORDLESS_AUTH_API_URL) is intentionally NOT required: when unset, the
    // passwordless caller falls back to the page's own origin (see authenticationApi). Clearing the
    // var is how an environment opts into the same-origin send.

    return url as string;
  }
}

export default ConfigService;
